import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';

const AdminPortal = ({ isAuthenticated, onLogin, onLogout }) => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = onLogin(credentials.username.trim(), credentials.password);

    if (!isValid) {
      setError('Invalid admin username or password.');
      return;
    }

    setError('');
    navigate('/admin/management');
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-portal-page">
        <div className="admin-portal-card">
          <Logo className="admin-logo" height={56} />
          <h1>Admin Sign In</h1>
          <p>Sign in to access the admin portal and management tools.</p>
          <form className="admin-login-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="username"
              placeholder="Username"
              value={credentials.username}
              onChange={handleChange}
              autoComplete="username"
              required
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={credentials.password}
              onChange={handleChange}
              autoComplete="current-password"
              required
            />
            {error && <p className="admin-login-error">{error}</p>}
            <button type="submit" className="btn btn-primary">Sign In</button>
          </form>
          <div className="admin-portal-actions">
            <Link to="/" className="btn btn-secondary">Back to Website</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-portal-page">
      <div className="admin-portal-card">
        <Logo className="admin-logo" height={56} />
        <h1>Admin Portal</h1>
        <p>Access management tools for pictures, testimonials, and content updates.</p>
        <div className="admin-portal-actions">
          <Link to="/admin/management" className="btn btn-primary">Open Management Panel</Link>
          <button type="button" className="btn btn-secondary" onClick={onLogout}>Sign Out</button>
          <Link to="/" className="btn btn-secondary">Back to Website</Link>
        </div>
      </div>
    </div>
  );
};

export default AdminPortal;
